import update from 'immutability-helper';
import { SAVE_SELECTION_RANGE } from '@/constants/ActionTypes';


const initialState = {
	selectionRange: null,
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case SAVE_SELECTION_RANGE:
			return update(state, {
				selectionRange: { $set: action.selectionRange },
			});
		default:
			return state;
	}
}

export default reducer;
